module.exports = __webpack_public_path__ + "img/golden_oak_696l_list.c9d61ae1.jpg";